import { LocalShipping, ShoppingBag, SupportAgent } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const AboutSectionOne: React.FC = () => {
  const theme = useTheme();
  const { t: myTranslate } = useTranslation();

  const features = [
    {
      icon: <SupportAgent sx={{ fontSize: 40 }} />,
      title: myTranslate("about.features.support247"),
      description: myTranslate("about.features.support247Desc"),
      color: theme.palette.warning.main,
    },
    {
      icon: <LocalShipping sx={{ fontSize: 40 }} />,
      title: myTranslate("about.features.shippingDelivery"),
      description: myTranslate("about.features.shippingDeliveryDesc"),
      color: theme.palette.warning.main,
    },
    {
      icon: <ShoppingBag sx={{ fontSize: 40 }} />,
      title: myTranslate("about.features.easyShopping"),
      description: myTranslate("about.features.easyShoppingDesc"),
      color: theme.palette.warning.main,
    },
  ];

  const stats = [
    {
      number: "1M+",
      label: myTranslate("about.stats.productsAvailable"),
      color: theme.palette.primary.main,
    },
    {
      number: "50+",
      label: myTranslate("about.stats.countriesServed"),
      color: theme.palette.primary.main,
    },
    {
      number: "100K+",
      label: myTranslate("about.stats.happyCustomers"),
      color: theme.palette.primary.main,
    },
    {
      number: "99.9%",
      label: myTranslate("about.stats.uptimeGuarantee"),
      color: theme.palette.primary.main,
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 3, md: 5 },
        backgroundColor: "transparent",
      }}
    >
      <Container maxWidth="xl">
        {/* Section Header */}
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
          <Typography
            variant="h2"
            className="notranslate"
            translate="no"
            sx={{
              fontSize: { xs: "2rem", md: "3rem" },
              fontWeight: 800,
              color: theme.palette.text.primary,
              mb: 2,
            }}
          >
            {myTranslate("about.ourMission")}
          </Typography>
          <Typography
            variant="h6"
            className="notranslate"
            translate="no"
            sx={{
              color: theme.palette.text.secondary,
              maxWidth: 600,
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            {myTranslate("about.missionDescription")}
          </Typography>
        </Box>

        {/* Features Grid */}
        <Grid container spacing={4} sx={{ mb: { xs: 6, md: 8 } }}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} lg={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  border: "none",
                  borderRadius: 3,
                  background: "white",
                  boxShadow: "none",
                  "&:hover": {
                    boxShadow: "none",
                  },
                  "&:hover .icon-avatar": {
                    transform: "scale(0.9)",
                  },
                }}
              >
                <CardContent sx={{ p: 4, textAlign: "center" }}>
                  <Avatar
                    className="icon-avatar"
                    sx={{
                      backgroundColor: `${feature.color}15`,
                      color: feature.color,
                      width: 80,
                      height: 80,
                      mx: "auto",
                      mb: 3,
                      transition: "transform 0.3s ease",
                    }}
                  >
                    {feature.icon}
                  </Avatar>

                  <Typography
                    variant="h6"
                    className="notranslate"
                    translate="no"
                    sx={{
                      fontWeight: 700,
                      mb: 2,
                      color: theme.palette.text.primary,
                    }}
                  >
                    {feature.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    className="notranslate"
                    translate="no"
                    sx={{
                      color: theme.palette.text.secondary,
                      lineHeight: 1.7,
                    }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutSectionOne;
